module.exports = __webpack_public_path__ + "img/eventbrite.97b99c12.png";